import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
import {httpResource} from "@/resources/http.resource";

export namespace AntiTheftActions {

  export async function getCarsStatuses(component: any, carId?: number): Promise<IAntiTheft.IStatusCars[]> {
    let result: IAntiTheft.IStatusCars[] = null;
    let asyncAction = async () => {
      const action = IAntiTheft.Action;
      const params: any = {
        command: IAntiTheft.Command.GetCars,
      };
      if (carId) params.carId = carId;
      const {data: {result: response }} = await httpResource.httpAction({ action, params });
      result = response;
    };

    await component.$store.dispatch('defaultResourceAction', { asyncAction });
    return result;
  }

  export async function changeStatus(component, payload: { carId: number; securityActive: boolean; scheduleActive: boolean; }) {
    let asyncAction = async () => {
      const action = IAntiTheft.Action;
      const params: any = {
        command: IAntiTheft.Command.SetStatus,
        carId: payload.carId,
        theftFlag: payload.securityActive,
        theftScheduleFlag: payload.scheduleActive,
      };
      return await httpResource.httpAction({ action, params });
    };

    return await component.$store.dispatch('defaultResourceAction', { asyncAction });
  }
}
